export default {
  AppException (message) {
    this.message = message
    this.name = 'AppException'
  }
}
